var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('i',_vm._g(_vm._b({class:'far fa-info-circle icon-tooltip fa-' + _vm.iconSize},'i',attrs,false),on))]}}])},[_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }